'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaults = {
  /**
   * 请求的类型
   */
  method: 'get',

  /**
   * request 类型: get,post...,jsonp,script
   */
  type: 'json',

  /**
   * 超时时间
   */
  timeout: 5000,

  /**
   * 头部信息
   */
  headers: {},

  /**
   * arms监控
   */
  arms: true,

  /**
   * log请求日志
   */
  log: false
};

exports.default = defaults;